import CityPageTemplate from "../city-template/CityPageTemplate";
import { saintClairShoresConfig } from "./data";

export default function SaintClairShoresPage() {
  return <CityPageTemplate config={saintClairShoresConfig} />;
}